<template>
  <filter-groupings-expand-toggle v-bind="$attrs" :cache-key="cacheKey" />
  <filter-grouping
    v-if="features.FILTER_COLLECTIONS && dropdownFilters"
    :title="dropdownFilters.filtercollection.label"
    icon="folder_special"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.filterCollectionFilterGroup"
    :has-filters="searchStore.hasFilters({ dropdown: ['filtercollection'] })"
    container-classes="filter-collections"
  >
    <dropdown-filter
      v-if="dropdownFilters.filtercollection && dropdownFilters.filtercollection.items?.length"
      :dropdown-filter="dropdownFilters.filtercollection"
      :show-title="false"
      @dropdown-change="triggerFiltering"
    />
    <div v-else class="no-filters-content">
      <p class="small">
        Select <router-link to="/videos">filters</router-link> and save the results as a collection.
      </p>
    </div>
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.fb"
    :title="checkboxFilters.fb.label"
    icon="dashboard"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.fbCollectionFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['fb'] })"
    container-classes="fb-collections"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.fb"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="dropdownFilters && dropdownFilters.specialtyprogram"
    :title="dropdownFilters.specialtyprogram.label"
    icon="list_alt"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.specialtyProgramsFilterGroup"
    :has-filters="searchStore.hasFilters({ dropdown: ['specialtyprogram'] })"
    container-classes="membership"
  >
    <dropdown-filter
      :dropdown-filter="dropdownFilters.specialtyprogram"
      :show-title="false"
      @dropdown-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.membership"
    :title="checkboxFilters.membership.label"
    icon="add_diamond"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.membershipFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['membership'] })"
    container-classes="membership"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.membership"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.difficulty"
    :title="checkboxFilters.difficulty.label"
    icon="local_fire_department"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.difficultyFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['difficulty'] })"
    container-classes="difficulty"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.difficulty"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.trainingtype"
    :title="checkboxFilters.trainingtype.label"
    icon="directions_run"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.trainingTypeFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['trainingtype'] })"
    container-classes="training-type"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.trainingtype"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useSearchFilter } from '@/composables/search-filter'
import { useSearchStore } from '@/stores/search'
import CheckboxFilter from '@/components/search/checkbox-filter.vue'
import FilterGrouping from '@/components/search/filter-grouping.vue'
import DropdownFilter from '@/components/search/dropdown-filter.vue'
import FilterGroupingsExpandToggle from '@/components/search/filter-groupings-expand-toggle.vue'

/** STATE **/
const searchStore = useSearchStore()

/** NON REACTIVE **/
// groupingIds and cacheKey use to persist expanded state to local storage
const groupingIds = {
  filterCollectionFilterGroup: 'filterCollectionFilterGroup',
  fbCollectionFilterGroup: 'fbCollectionFilterGroup',
  specialtyProgramsFilterGroup: 'specialtyProgramsFilterGroup',
  membershipFilterGroup: 'membershipFilterGroup',
  difficultyFilterGroup: 'difficultyFilterGroup',
  trainingTypeFilterGroup: 'trainingTypeFilterGroup',
}

// local storage cache key for which filters are expanded
const cacheKey = 'video-browse-filter-groupings-expanded-v1'

/** EMITS **/
const emit = defineEmits(['filter-update'])

/** COMPOSABLES **/
const {
  features,
  checkboxFilters,
  dropdownFilters,
  triggerFiltering,
  initFilterGroupingsExpandedCache,
} = useSearchFilter({ emit })

/** LIFECYCLE **/
onBeforeMount(() => {
  // init expanded state from local storage
  initFilterGroupingsExpandedCache({ cacheKey, groupingIds })
})
</script>
